/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export type DeviceStatus = (typeof DeviceStatus)[keyof typeof DeviceStatus];

export const DeviceStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
  UNPLUGGED: 'unplugged',
} as const;
